var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7836 8.8058C24.8034 6.31661 23.1018 4.16394 20.8891 2.61387C18.6764 1.0638 16.0496 0.184271 13.3333 0.0839844C10.6169 0.184271 7.99009 1.0638 5.77737 2.61387C3.56466 4.16394 1.86306 6.31661 0.882899 8.8058C0.816703 8.98556 0.816703 9.18241 0.882899 9.36217C1.86306 11.8514 3.56466 14.004 5.77737 15.5541C7.99009 17.1042 10.6169 17.9837 13.3333 18.084C16.0496 17.9837 18.6764 17.1042 20.8891 15.5541C23.1018 14.004 24.8034 11.8514 25.7836 9.36217C25.8498 9.18241 25.8498 8.98556 25.7836 8.8058ZM13.3333 14.4022C12.2619 14.4022 11.2146 14.0903 10.3238 13.5059C9.43304 12.9215 8.73875 12.0909 8.32876 11.1192C7.91878 10.1474 7.81151 9.07808 8.02051 8.04646C8.22952 7.01483 8.74543 6.06722 9.50298 5.32346C10.2605 4.5797 11.2257 4.07319 12.2765 3.86799C13.3272 3.66279 14.4164 3.7681 15.4062 4.17063C16.396 4.57315 17.242 5.25479 17.8372 6.12936C18.4324 7.00393 18.7501 8.03215 18.7501 9.08398C18.7479 10.4938 18.1765 11.8452 17.1611 12.8421C16.1457 13.839 14.7692 14.4 13.3333 14.4022Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBlack);
export default __webpack_public_path__ + "static/media/viewBlack.20bbd5e9537610f4109741519bfa4b1a.svg";
export { ForwardRef as ReactComponent };